import CompanyMap from 'app/constants/companyMap.constant.json';

export const companyMap = CompanyMap;

const getDomainName = () => {
	const hostname = window.location.hostname;

	if (hostname.includes('arkannect')) {
		return 'arkannect';
	}

	return hostname.split('.').length === 3 ? hostname.split('.')[0] : '';
};

// export const subDomainName = 'arkannect'; // DEBUG: Locally testing enterprise subdomain
export const subDomainName = getDomainName();

export const hasSubDomain = companyMap[subDomainName];

export const checkSubDomain = () => {
	if (hasSubDomain) {
		const companyKey = subDomainName;

		if (!companyKey || !companyMap[companyKey]) return;

		const mapping = companyMap[companyKey];

		document.title = mapping.title;

		var link = document.querySelector("link[rel~='icon']");
		if (!link) {
			link = document.createElement('link');
			link.rel = 'icon';
			document.getElementsByTagName('head')[0].appendChild(link);
		}
		link.href = mapping.favicon;

		const root = document.documentElement;
		root.style.setProperty('--brandingbase', mapping.themecolor);
		root.style.setProperty('--loaderanimationprimarycolor', mapping.themecolor);
		if (mapping.secondarythemecolor) {
			root.style.setProperty('--textsecondary', mapping.secondarythemecolor);
			root.style.setProperty('--loaderanimationsecondarycolor', mapping.secondarythemecolor);
		}
	}
};

export const getSubdomainBasedMapping = () => {
	if (!hasSubDomain) return null;
	return companyMap[subDomainName];
};

export const getSubdomainBasedLogo = () => {
	return getSubdomainBasedMapping() ? getSubdomainBasedMapping().logo : null;
};

export const getSubdomainBasedLoginConfig = () => {
	const mapping = getSubdomainBasedMapping();
	if (!mapping) return null;
	if (mapping.login) return mapping.login;
	return null;
};
